import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ScanFace } from "lucide-react";
import api from "@/lib/api";

export default function FaceEnrollPrompt({ employeeId }) {
    const [pending, setPending] = useState(false);
    useEffect(() => {
        if (employeeId) api.get(`/employees/${employeeId}/face/status`).then(({ data }) => setPending(!data.enrolled)).catch(() => {});
    }, [employeeId]);
    if (!pending) return null;
    return (
        <Link to="/face-enroll" className="mt-8 flex items-center gap-4 bg-amber-50 border border-amber-200 p-5 hover:bg-amber-100/60" data-testid="face-enroll-prompt">
            <ScanFace className="w-8 h-8 text-amber-700 shrink-0" />
            <div className="flex-1">
                <div className="font-semibold text-ink">Enroll your face for clock-in</div>
                <div className="text-sm text-ink/60">Takes about 30 seconds — just look at the camera.</div>
            </div>
            <span className="text-sm text-klein font-medium">Start →</span>
        </Link>
    );
}
